// @flow

/**
 * Module dependencies.
 */

import { SuccessMessage } from 'client/components/forms/components/messages';
import { compose } from 'recompose';
import { defaultTransition, units } from 'client/styles';
import { translator } from 'core/utils';
import Layout from 'client/components/core/layout';
import React from 'react';
import styled from 'styled-components';

/**
 * `Content` type.
 */

type Content = {
  button: string,
  buttonThemeColor?: string,
  message: string,
  renderIcon?: boolean,
  title: string
};

/**
 * `Props` type.
 */

type Props = {
  children: React$Element<*>,
  content: Content,
  formVisible: boolean,
  resetForm: Function,
  successVisible: boolean,
  translate: Function
};

/**
 * `FormWrapper` styled component.
 */

const FormWrapper = styled.div`
  position: relative;
  transition: ${defaultTransition};
  transition-property: opacity, transform;

  ${({ visible }: Object): string => `
    opacity: ${visible ? 1 : 0};
    transition-delay: ${visible ? 0 : 0.35}s;
    pointer-events: ${visible ? 'all' : 'none'};
    transform: translate3d(0, ${visible ? '0' : units(-5)}, 0);
  `}
`;

/**
 * `FormContainer` component.
 */

function FormContainer(props: Props): React$Element<*> {
  const {
    children,
    content,
    formVisible,
    resetForm,
    successVisible,
    translate
  } = props;

  const defaultContent = {
    button: translate('formRequest.message.success.button'),
    message: translate('formRequest.message.success.message'),
    renderIcon: true,
    title: translate('formRequest.message.success.title')
  };

  const { button, buttonThemeColor, message, renderIcon, title } = {
    ...defaultContent,
    ...content
  };

  return (
    <Layout position={'relative'}>
      <FormWrapper visible={formVisible}>
        {children}
      </FormWrapper>

      <SuccessMessage
        button={button}
        buttonAction={resetForm}
        buttonThemeColor={buttonThemeColor}
        message={message}
        renderIcon={renderIcon}
        title={title}
        visible={successVisible}
      />
    </Layout>
  );
}

/**
 * Export `FormContainer`.
 */

export default compose(
  translator()
)(FormContainer);



// WEBPACK FOOTER //
// ../src/client/components/forms/components/form-container.js